module.exports = __webpack_public_path__ + "static/media/8.5ea12a4c.jpg";